<template>
  <div id="app">
    <!-- robohash to avataaars -->
    <b-button v-if="presentationMode && showPresentationModeEscapeButton" @click="escapePresentationMode" size="sm" variant="secondary" id="presentationButton" style="z-index: 10000; position : absolute; top: 0.2rem; right: 0.2rem; background-color:rgba(128, 128, 128, 0.5); color: black;" class="pt-dot1 pb-dot1 pl-2 pr-2 fontSizeDot8">
      {{ $t("tHeader.endPresentation") }}
    </b-button>
    <tHeader v-if="!presentationMode"/>
    <tAlert v-if="!presentationMode" />
    <ticker v-if="!presentationMode && !notLoginConfirmed && loginUserDeepBinding && loginUserBinded && $route.name != 'tinkHome'" />
    <router-view/>
    <tFooter v-if="!presentationMode" v-touch:touchhold="togglePresentationMode" v-touch:swipe="swipeApp"/>
    <!--tAdmin v-if="this.currentUser && this.currentUser.email == 'data.tinkable@gmail.com'" /-->
  </div>
</template>

<script>
  import tHeader from "@/components/tHeader.vue"
  import tFooter from "@/components/tFooter.vue"
  import tAlert from "@/components/tAlert.vue"
  import ticker from "@/components/ticker.vue"

  // import tAdmin from "@/components/tAdmin.vue"

  require("@/assets/css/base.css")
  require("@/assets/css/map.css")

  import firebase from "firebase/app";
  import "firebase/auth";
  import "firebase/firestore";

  import { db } from "@/plugins/firebase.js"

  import eventBus from '@/plugins/eventBus.js'

  import { mapActions } from "vuex"
  import { mapState } from "vuex"
  import { mapSetter } from "@/plugins/vuexUtils.js"

  import uiUtil from "@/mixins/util.js"
  import user from "@/mixins/user.js"

  export default {
    name: "App",
    components: {
      tHeader,
      tAlert,
      ticker,
      tFooter,
      // tUserFloat,
      // tAdmin,
    },
    data: function() {
      return {
        elapsedStartTime: null,
      }
    },
    mixins: [uiUtil, user],
    created: function() {

      firebase.auth().onAuthStateChanged((user) => {
        this.$log.debug("onAuthStateChanged", (new Date()).getTime())
        if(user) {
          let loginUserRef = db.collection("/users").doc(firebase.auth().currentUser.uid)
          loginUserRef.get().then((user) => {
            this.$log.debug("loginUser get", (new Date()).getTime())

            if(user.exists) {
              if(typeof(user.data().withdrawn) != "undefined" && user.data().withdrawn) {
                firebase.auth().signOut();
                window.alert("탈퇴한 사용자라서 로그인할 수 없습니다.");
              }
              else {

                this.notLoginConfirmed = false;
                this.$store.state.currentUser = firebase.auth().currentUser

                let toUpdate = {
                  lastLogin: firebase.firestore.FieldValue.serverTimestamp(),
                  email: firebase.auth().currentUser.email,
                };

                if(typeof(user.data().friends) != "undefined") {
                  toUpdate.friends = firebase.firestore.FieldValue.delete();
                }

                if(typeof(user.data().useTicker) != "undefined") {
                  toUpdate.useTicker = firebase.firestore.FieldValue.delete();
                }

                if(typeof(user.data().uiShowTicker) != "undefined") {
                  toUpdate.uiShowTicker = firebase.firestore.FieldValue.delete();
                }

                if(typeof(user.data().uiShowUserInfo) != "undefined") {
                  toUpdate.uiShowUserInfo = firebase.firestore.FieldValue.delete();
                }

                if(typeof(user.data().showTicker) != "undefined") {
                  toUpdate.showTicker = firebase.firestore.FieldValue.delete();
                }

                let needDeviceSensorFrUpdate = false;

                if(typeof(user.data().frApp) == "undefined") {
                  toUpdate.frApp = [];
                  needDeviceSensorFrUpdate = true;
                }

                if(typeof(user.data().deepBinding) == "undefined") {
                  toUpdate.deepBinding = true;
                }

                if(typeof(user.data().frAppCache) == "undefined") {
                  toUpdate.frAppCache = {};
                }
                if(typeof(user.data().frReq) == "undefined") {
                  toUpdate.frReq = {};
                }

                if(typeof(user.data().openEmail) == "undefined") {
                  toUpdate.openEmail = true;
                }
                if(typeof(user.data().openFriends) == "undefined") {
                  toUpdate.openFriends = true;
                }
                if(typeof(user.data().openAdmin) != "undefined") {
                  toUpdate.openAdmin = firebase.firestore.FieldValue.delete();
                }
                if(typeof(user.data().openBookmark) == "undefined") {
                  toUpdate.openBookmark = false;
                }

                if(typeof(user.data().folders) == "undefined") {
                  toUpdate.folders = [];
                }

                if(typeof(user.data().foldersInfo) == "undefined") {
                  toUpdate.foldersInfo = {};
                  let index=0;
                  for(let item in user.data().devices) {
                    toUpdate.foldersInfo[item] = {
                      "id": item,
                      "folder": "@root",
                      "index": index++
                    }
                  }
                }
                else {

                  for(let item in user.data().devices) {

                    if(typeof(user.data().foldersInfo[item]) != "undefined") {

                      if(user.data().foldersInfo[item].folder != "@root" && !user.data().folders.some( folder => {
                        return folder == user.data().foldersInfo[item].folder
                      })) {
                        if(user.data().foldersInfo[item].name) {
                          toUpdate['foldersInfo.' + item] = {
                            "id": item,
                            "folder": "@root",
                            "name": user.data().foldersInfo[item].name,
                            "index": user.data().foldersInfo[item].index
                          }
                        }
                        else {
                          toUpdate['foldersInfo.' + item] = {
                            "id": item,
                            "folder": "@root",
                            "index": user.data().foldersInfo[item].index
                          }
                        }
                      }
                    }
                    else {
                      toUpdate['foldersInfo.' + item] = {
                        "id": item,
                        "folder": "@root",
                        "index": 1000
                      }
                    }
                  }
                  this.$log.debug("--foldersInfo", user.data().foldersInfo);
                  this.$log.debug("--toUpdate", toUpdate);
                }

                if(typeof(user.data().bookmarks) == "undefined") {
                  toUpdate.bookmarks = [{"name": "default", "list": [] }];
                }

                this.$log.debug("loginUser before update", (new Date()).getTime(), needDeviceSensorFrUpdate)

                db.collection("/users").doc(firebase.auth().currentUser.uid).update(toUpdate).then(()=>{

                  this.$log.debug("App.vue loginUser update", (new Date()).getTime())

                  this.storeBindingLoginUserRef((user.data().deepBinding || needDeviceSensorFrUpdate)? 2: 0).then(() => {

                    this.$log.debug("App.vue after storeBindingLoginUserRef", (new Date()).getTime())


                    window.setTimeout(() => {
                      if(this.loginUser.deepBinding) {
                        for(let device in this.loginUser.devices) {
                          this.loginUser.foldersInfo[device].name = this.loginUser.devices[device].name;
                        }
                      }

                      this.loginUserOpen = this.loginUser.open
                      this.loginUserDeepBinding = this.loginUser.deepBinding
                      this.loginUserBinded = true;

                      this.editProfileDisplayName = this.loginUser.displayName
                      this.editProfileDescription = this.loginUser.description
                      this.editProfilePhotoURL = this.loginUser.photoURL

                      this.isNewUser = window.localStorage.getItem("isNewUser")
                      this.providerId = window.localStorage.getItem("providerId")

                      if(needDeviceSensorFrUpdate) {
                        let batch = db.batch();
                        let deviceId, sensorName;
                        for(deviceId in this.loginUser.devices) {
                          batch.update(db.collection("devices").doc(this.loginUser.devices[deviceId].id), {
                            "frApp": [],
                            "frAppCache": {},
                            "admin": "",
                            "inherit": true,
                            "friends": firebase.firestore.FieldValue.delete()
                          });
                          for(sensorName in this.loginUser.devices[deviceId].sensors) {
                            batch.update(db.collection("sensors").doc(this.loginUser.devices[deviceId].sensors[sensorName].id), {
                              "frApp": [],
                              "frAppCache": {},
                              "admin": "",
                              "inherit": true,
                              "friends": firebase.firestore.FieldValue.delete()
                            });
                          }
                        }
                        batch.commit()
                        .then(() => {
                          this.makeToast("success", "기기와 센서 업데이트 성공", "기기와 센서를 새로운 기능에 맞추어서 업데이트했습니다.");
                        })
                        .catch(error => {
                          this.makeToast("danger", "기기와 센서 업데이트 실패", "기기와 센서를 업데이트하는 중에 에러가 발생했습니다. 에러 내용: " + error);
                        })
                      }
                    }, 500);
                  })
                  .catch((error) => {
                    this.makeToast("danger", "로그인 처리 에러", "사용자 정보 업데이트 후에 다시 가져오다가 에러가 발생했습니다.에러 내용: " + error);
                  })
                }).catch((error) => {
                  this.makeToast("danger", "로그인 처리 에러", "사용자 정보를 수정 업데이트하다가 에러가 났습니다. 에러 내용: " + error);
                })

              }
            }
            else {

              this.notLoginConfirmed = false;
              this.$store.state.currentUser = firebase.auth().currentUser

              db.collection("/users").doc(firebase.auth().currentUser.uid).set({
                displayName: firebase.auth().currentUser.displayName,
                email: firebase.auth().currentUser.email,
                open: true,
                disabled: false,
                frApp: [],
                frAppCache: {},
                frReq: {},
                devices: {},
                emailVerified: firebase.auth().currentUser.emailVerified,
                photoURL: "",
                description: "",
                creation: firebase.firestore.FieldValue.serverTimestamp(),
                lastLogin: firebase.firestore.FieldValue.serverTimestamp(),
                deepBinding: true,
                showTicker: false,
                openEmail: true,
                openFriends: true,
                openBookmark: false,
                folders: [],
                foldersInfo: {},
                bookmarks: [{"name": "default", "list": []}],
              }).then(()=>{

                this.storeBindingLoginUserRef(2).then(() => {

                  this.loginUserOpen = this.loginUser.open
                  this.loginUserDeepBinding = this.loginUser.deepBinding

                  this.loginUserBinded = true;

                  this.editProfileDisplayName = this.loginUser.displayName
                  this.editProfileDescription = this.loginUser.description
                  this.editProfilePhotoURL = this.loginUser.photoURL

                  this.isNewUser = window.localStorage.getItem("isNewUser")
                  this.providerId = window.localStorage.getItem("providerId")
                })

              }).catch((error) => {
                this.makeToast("danger", "로그인 처리 에러", "새로운 사용자 정보를 저장하다가 에러가 났습니다. 에러 내용: " + error);
              })
            }
          }).catch((error) => {
            this.makeToast("danger", "로그인 처리 에러", "데이터베이스에서 로그인 사용자 정보를 가져오다 에러가 났습니다. 에러 내용: " + error);
          })
        }
        else {
          this.storeUnbindingLoginUserRef()
          .then(() => {
            this.loginUserBinded = false;
            this.notLoginConfirmed = true;
            this.$log.debug("App.vue", "storeUnbindingLoginUserRef then", "notLoginConfirmed", this.notLoginConfirmed)
          })
        }
      })
    },
    mounted: function() {
      eventBus.$on('busAddDevice', () => {
        this.addDevice()
      })

      eventBus.$on('busTogglePresentationMode', () => {
        this.togglePresentationMode();
      })

      eventBus.$on('busSetPresentationMode', flag => {
        this.setPresentationMode(flag);
      })

      eventBus.$on('busEscapePresentationMode', () => {
        this.escapePresentationMode();
      })

      eventBus.$on('setElapsedStartTime', () => {
        this.setElapsedStartTime();
      })

      // config.options.scales.xAxes
      // config.options.scales.yAxes

      // options.scales.xAxes
      // options.scales.yAxes


      eventBus.$on('showElapsed', (msg) => {
        this.showElapsed(msg);
      })

    },
    updated: function() {
      this.$log.debug("App.vue currentUser", this.currentUser);
      this.$log.debug("App.vue loginUser", this.loginUser);
    },
    methods: {
      setElapsedStartTime: function() {
        this.elapsedStartTime = new Date();
      },
      showElapsed: function(msg) {
        if(this.elapsedStartTime) {
          console.log(msg + ": " + ((new Date()).getTime() - this.elapsedStartTime.getTime())/1000);
          this.elapsedStartTime = null;
        }
      },
      togglePresentationMode: function() {
        this.presentationMode = !this.presentationMode;
      },
      setPresentationMode: function(flag) {
        this.presentationMode = flag;
      },
      escapePresentationMode: function() {
        this.presentationMode = false;
      },
      swipeApp: function(direction) {
        this.$log.debug("swife", direction);
        if(direction == "left") {
          eventBus.$emit("busUiShow", "myMenuShow");
          eventBus.$emit("busShowPageUser", false);
        }
        else if(direction == "right") {
          eventBus.$emit("busUiHide", "myMenuShow");
          eventBus.$emit("busShowPageUser", true);
        }
      },
      addDevice: function() {
        this.storeAddDevice()
        .then((added)=>{
          this.$router.push({
            name: "user-device",
            params: {
              uid: this.loginUser.id,
              did: added.id,
            },
            query: {
              mode: "edit",
            },
          })
        })
      },
      ...mapActions(['storeAddDevice', 'storeBindingLoginUserRef', 'storeUnbindingLoginUserRef']),
    },
    computed: {
      ...mapSetter(
        mapState({
          currentUser: state => state.currentUser,
          providerId: state => state.providerId,
          isNewUser:  state => state.isNewUser,
        })
      )
    },
  }
</script>
